import styled from 'styled-components'
import { SecondaryButton } from './Button'
import { RADOM_COLORS } from '../util/Constants'
import React, { ReactNode } from 'react'
import PaymentMethodDisplay from './PaymentMethodDisplay'
import { DepositAccountDetails, ExternalAccount, FiatAccountType, FiatDepositAccountType, WithdrawalAccountDetails } from '../state/Radom'
import { getMethod } from '../util/Managed'

export const DateRange = styled(SecondaryButton)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  color: ${RADOM_COLORS.BLACK};
  border: 0;
`

export const SectionBreakerHorizontal = styled.div`
  width: 100%;
  border-bottom: 1px solid ${RADOM_COLORS.GRAY_DARK};
`

export const SectionBreakerVertical = styled.div`
  height: 100%;
  border-left: 1px solid ${RADOM_COLORS.GRAY_DARK};
`

export const ClickableSection = styled.div`
  padding: 20px 16px;
  border-radius: 10px;
  border: 1px solid ${RADOM_COLORS.GRAY_DARK};
  box-shadow: 0 0 3px ${RADOM_COLORS.GRAY_DARK};
  display: flex;
  flex-direction: column;
  gap: 30px;
  &:hover {
    background-color: ${RADOM_COLORS.GRAY_LIGHTEST};
  };
  background-color: var(--surface, #ffffff);
`

export const formatFiatAccountType = (accountDetails: FiatAccountType): ReactNode => {
  return <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>

    <img
      style={{
        width: 25,
        maxHeight: 25,
        maxWidth: 25
      }}
      src={`https://pay.radom.com/flags/${accountDetails.accountType.us ? 'us' : 'eu'}.svg`}
    />

    <span>{accountDetails.accountType.us ? 'USD' : 'EUR'} account</span>
  </div>
}

export const formatFiatAccountDetails = (accountDetails: FiatAccountType): ReactNode => {
  if (accountDetails.accountType.us) {
    return <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5, flexDirection: 'column' }}>
      {accountDetails.accountOwnerName}
      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Bank</span>
        <span>{accountDetails.accountType.us?.bankName}</span>
      </div>
      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Account #</span>
        <span>{accountDetails.accountType.us?.accountNumber}</span>
      </div>

      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Routing #</span>
        <span>{accountDetails.accountType.us?.routingNumber}</span>
      </div>
    </div>
  }

  if (accountDetails.accountType.iban) {
    return <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5, flexDirection: 'column' }}>
      {accountDetails.accountOwnerName}
      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>IBAN #</span>
        <span>{accountDetails.accountType.iban?.iban}</span>
      </div>

      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>BIC #</span>
        <span>{accountDetails.accountType.iban?.bic}</span>
      </div>
    </div>
  }

  return <></>
}

export const formatDepositFiatAccountType = (accountDetails: FiatDepositAccountType): ReactNode => {
  return <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>

    <img
      style={{
        width: 20,
        maxHeight: 20,
        maxWidth: 20
      }}
      src={`https://pay.radom.com/flags/${accountDetails.accountType.us ? 'us' : 'eu'}.svg`}
    />

    <span>{accountDetails.accountType.us ? 'USD' : 'EUR'} account</span>
  </div>
}

export const formatDepositFiatAccountDetails = (accountDetails: FiatDepositAccountType): ReactNode => {
  if (accountDetails.accountType.us) {
    return <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5, flexDirection: 'column' }}>
      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Bank</span>
        <span>{accountDetails.bankName}</span>
      </div>
      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Account #</span>
        <span>{accountDetails.accountType.us?.accountNumber}</span>
      </div>

      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Routing #</span>
        <span>{accountDetails.accountType.us?.routingNumber}</span>
      </div>
    </div>
  }

  if (accountDetails.accountType.iban) {
    return <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5, flexDirection: 'column' }}>
      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Bank</span>
        <span>{accountDetails.bankName}</span>
      </div>

      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>IBAN #</span>
        <span>{accountDetails.accountType.iban?.iban}</span>
      </div>

      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>BIC #</span>
        <span>{accountDetails.accountType.iban?.bic}</span>
      </div>
    </div>
  }

  return <></>
}

export const formatWithdrawalAccountType = (accountDetails: WithdrawalAccountDetails): ReactNode => {
  if (accountDetails.Crypto) {
    return <PaymentMethodDisplay method={{ network: accountDetails.Crypto.network }} />
  }

  if (accountDetails.Fiat) {
    return formatFiatAccountType(accountDetails.Fiat)
  }

  return ''
}

export const formatWithdrawalAccount = (accountDetails: WithdrawalAccountDetails): ReactNode => {
  if (accountDetails.Crypto) {
    return accountDetails.Crypto.address
  }

  if (accountDetails.Fiat) {
    return formatFiatAccountDetails(accountDetails.Fiat)
  }

  return ''
}

export const formatDepositAccountType = (accountDetails: DepositAccountDetails): ReactNode => {
  if (accountDetails.Crypto) {
    return <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
      {
        accountDetails.Crypto.depositMethods.slice(0, 3).map(m =>

          <PaymentMethodDisplay
            key={m.network + (m.token ?? '')}
            method={{ network: m.network, token: m.token }}
            excludeName
            showNetworkBadge
            disableTooltip={false} />
        )
      }
      {accountDetails.Crypto.depositMethods.length > 3 && `+${accountDetails.Crypto.depositMethods.length - 3}`}
    </div>
  }

  if (accountDetails.Fiat) {
    return formatDepositFiatAccountType(accountDetails.Fiat)
  }

  return ''
}

export const formatDepositAccount = (accountDetails: DepositAccountDetails): ReactNode => {
  if (accountDetails.Crypto) {
    return accountDetails.Crypto.address
  }

  if (accountDetails.Fiat) {
    return formatDepositFiatAccountDetails(accountDetails.Fiat)
  }

  return ''
}

// ============================================
// External Account formatting helpers
// ============================================

const ACCOUNT_TYPE_LABELS: Record<string, string> = {
  us: 'USD account',
  iban: 'EUR account',
  clabe: 'MXN account (CLABE)',
  pix: 'BRL account (Pix)',
  gb: 'GBP account',
  unknown: 'SWIFT account',
  crypto: 'Wallet'
}

const ACCOUNT_TYPE_FLAGS: Record<string, string> = {
  us: 'us',
  iban: 'eu',
  clabe: 'mx',
  pix: 'br',
  gb: 'gb',
  unknown: 'un',
  crypto: 'crypto'
}

export const formatExternalAccountType = (account: ExternalAccount): ReactNode => {
  if (account.accountType === 'crypto' && account.crypto) {
    const method = getMethod(account.crypto.network)
    return <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      {method.logo && <img
        style={{ width: 25, maxHeight: 25, maxWidth: 25 }}
        src={method.logo}
      />}
      <span>{method.name}</span>
    </div>
  }
  const flag = ACCOUNT_TYPE_FLAGS[account.accountType] || 'un'
  const label = ACCOUNT_TYPE_LABELS[account.accountType] || account.accountType
  return <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
    <img
      style={{ width: 25, maxHeight: 25, maxWidth: 25 }}
      src={`https://pay.radom.com/flags/${flag}.svg`}
    />
    <span>{label}</span>
  </div>
}

export const formatExternalAccountDetails = (account: ExternalAccount): ReactNode => {
  const items: Array<{ label: string, value: string }> = []

  if (account.account) {
    items.push({ label: 'Account', value: `****${account.account.last4}` })
    items.push({ label: 'Routing #', value: account.account.routingNumber })
    if (account.account.checkingOrSavings) {
      items.push({ label: 'Type', value: account.account.checkingOrSavings })
    }
  } else if (account.iban) {
    items.push({ label: 'IBAN', value: `****${account.iban.last4}` })
    if (account.iban.bic) items.push({ label: 'BIC', value: account.iban.bic })
    if (account.iban.country) items.push({ label: 'Country', value: account.iban.country })
  } else if (account.clabe) {
    items.push({ label: 'CLABE', value: `****${account.clabe.last4}` })
  } else if (account.pixKey) {
    if (account.pixKey.accountPreview) items.push({ label: 'Pix Key', value: account.pixKey.accountPreview })
  } else if (account.brCode) {
    if (account.brCode.accountPreview) items.push({ label: 'BR Code', value: account.brCode.accountPreview })
  } else if (account.gbAccount) {
    items.push({ label: 'GB Account', value: `****${account.gbAccount.last4}` })
    items.push({ label: 'Sort Code', value: account.gbAccount.sortCode })
  } else if (account.swift) {
    items.push({ label: 'SWIFT', value: `****${account.swift.last4}` })
    items.push({ label: 'BIC', value: account.swift.bic })
  } else if (account.crypto) {
    const addr = account.crypto.address
    const truncated = addr.length > 12 ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : addr
    items.push({ label: 'Address', value: truncated })
    items.push({ label: 'Network', value: account.crypto.network })
  }

  return <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5, flexDirection: 'column' }}>
    {account.accountOwnerName}
    {items.map((item, i) => (
      <div key={i} style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>{item.label}</span>
        <span>{item.value}</span>
      </div>
    ))}
  </div>
}

export const SubTitle = styled.div`
  font-size: 12.25px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--text-muted, #6f7888);
  display: flex;
  align-items: center;
  gap: 4px;
`

export const Section = styled.div`
  padding: 22px 24px;
  border-radius: 18px;
  border: 1px solid var(--surface-pressed, #edf1f7);
  background: var(--surface, #ffffff);
  box-shadow: none;
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0;
`

export const SectionContent = styled.div<{ numColumns?: number }>`
  display: grid;
  grid-template-columns: repeat(${({ numColumns }) => numColumns || 2}, minmax(0, 1fr));
  gap: 18px 24px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const SectionItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`

export const SectionBreaker = styled.div`
  width: 100%;
  margin: 0;
  border-bottom: 1px solid var(--surface-pressed, #eef2f7);
`
